import { useGetCostCenters } from 'queries';
import { useFormContext } from 'react-hook-form';

import { CostCenters } from '../types';

import { getFormattedCostCenters } from '../utils/getFormattedCostCenters';

import { ControlledSelect } from 'components/shared';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';

interface Props {
  label: string;
  name: string;
}

const selector = (data) =>
  (data?.map((item) => ({
    value: item.brDynId,
    label: getFormattedCostCenters<CostCenters>({
      codeField: 'code',
      fromField: 'valid.from',
      toField: 'valid.to',
      nameField: 'name',
      item: item
    })
  })) as Option[]) ?? [];

export const CostCentersSelect = ({ label, name }: Props) => {
  const { control } = useFormContext();
  const { data: options } = useGetCostCenters(selector);

  return (
    <ControlledSelect
      variant="outlined"
      control={control}
      label={label}
      name={name}
      options={options ?? []}
    />
  );
};
